import React from "react";
import { SearchableDropdown } from "components";
import { PropertyResponse } from "store/reducers/products/properties/pl-properties.types";
import colors from "theme/colors";
import { useDispatch } from "react-redux";
import { editPropertyAction } from "store/reducers/products/properties/pl-properties.actions";
import {
  editSubPropertyAction,
  editStandardSubPropertyPL,
} from "store/reducers/products/subproperties/pl-subproperties.actions";
import { useParentPropertyContext } from "../../pages/ProductDetail/ProductLineProperties/ParentPropertyContext";

export function PropertiesDropdown({
  options,
  getOptionLabel,
  getOptionKey,
  placeholder,
  currentValue,
  multiselect,
  propertyData,
  propertyParameterType,
  type,
  clearable = false,
}: {
  options: any;
  getOptionLabel?: any;
  getOptionKey?: any;
  placeholder?: any;
  currentValue: any;
  multiselect: any;
  propertyData: PropertyResponse;
  propertyParameterType:
    | "dataType"
    | "rulesetids"
    | "tagids"
    | "domain"
    | "autoSelection";
  type?: string;
  clearable?: boolean;
}) {
  const dispatch = useDispatch();
  const { parentId } = useParentPropertyContext();

  const handleChange = (e: any) => {
    const newProperty = {
      ...propertyData,
      [propertyParameterType]: e,
    };
    if (type === "main") {
      if (propertyParameterType === "rulesetids") {
        newProperty.ruleSets = options.filter((option) =>
          e.includes(option.id)
        );
      }

      if (propertyParameterType === "tagids") {
        newProperty.tags = options.filter((option) => e.includes(option.id));
      }
      dispatch(
        editPropertyAction({
          propertyId: propertyData.id,
          property: newProperty,
          updatePayload: { [propertyParameterType]: e },
        })
      );
    }
    if (type === "subproperties") {
      dispatch(
        editSubPropertyAction({
          propertyId: propertyData.id,
          updatePayload: { [propertyParameterType]: e },
          parentId: parentId ? parentId : "",
          propertyData: propertyData,
        })
      );
    }
    if (type === "standardSubProperty") {
      dispatch(
        editStandardSubPropertyPL({
          propertyId: propertyData.id,
          changedProperty: { [propertyParameterType]: e },
          parentId,
        })
      );
    }
  };

  return (
    <SearchableDropdown
      multiselect={multiselect}
      searchable={true}
      clearable={clearable}
      disabled={!options.length}
      placeholder={placeholder || currentValue}
      options={options || []}
      getOptionLabel={getOptionLabel}
      getOptionKey={getOptionKey}
      value={currentValue}
      handleValueChange={handleChange}
      id={propertyParameterType + "customDropdownUUID"}
      name={propertyParameterType}
      noShadow
      noHoverBorder
      backgroundColor={colors.tables.hoveredCell}
    />
  );
}
